import { NgModule } from '@angular/core';
import {PrescriptionRepository} from './prescription/impl/service/ngrx/prescription.repository';
import {PrescriptionDataService} from './prescription/impl/service/ngrx/prescriptionData.service';
import {EntityDataService, EntityServices} from '@ngrx/data';
import {PrescriptionDefinitionModule} from "./definition/prescriptionDefinition.module";



@NgModule({
    imports: [
        PrescriptionDefinitionModule
    ]
})
export class PrescriptionModule {
    constructor(entityDataService: EntityDataService,
                entityServices: EntityServices,
                dataService: PrescriptionDataService,
                service: PrescriptionRepository,
    ) {

        entityDataService.registerServices({
            Prescription: dataService,
        });

        entityServices.registerEntityCollectionServices({
            Prescription: service,
        });
    }
}
